import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabsLabelFn = /* @__PURE__ */ createRecipe('tabs-label', {}, [])

const tabsLabelVariantMap = {}

const tabsLabelVariantKeys = Object.keys(tabsLabelVariantMap)

export const tabsLabel = /* @__PURE__ */ Object.assign(memo(tabsLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'tabsLabel',
  __getCompoundVariantCss__: tabsLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tabsLabelVariantKeys,
  variantMap: tabsLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabsLabelVariantKeys)
  },
  getVariantProps: tabsLabelFn.getVariantProps,
})